var _style, _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 848 875",
    style: {
      enableBackground: "new 0 0 848 875"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1AA29B;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 413,
    cy: 398.3,
    r: 383.2
  })), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.2,623.3l14.3,67.3h30.2l-26.7-115.1C306,591.4,300.1,607.4,294.2,623.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M481.4,558.4c19.9,17.2,39.8,34.3,59.7,51.5l-10.7,80.7h26.2l13.3-95.9l-63.9-52 C497.8,547.9,489.6,553.1,481.4,558.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M587.4,511.4l14.2-69.2c-10.4-9.1-20.8-18.1-31.2-27.2c8.9-3.5,38.1-16.1,56.5-48.6c5.8-10.3,21.9-38.1,13-71 c-4.8-17.9-15-29.9-21.2-36.2c1.5,10.2,5.2,44.8-15.7,79.9c-17.8,29.9-43.4,43.4-53.4,48H405.8L303.2,268.9 c-12.8,15.5-40.3,20.4-40.3,20.4c8.4-3.6,16.2-8.4,23.2-14.2c13.2-11,20.6-23.2,24.5-31c-17.1,5.5-34.7,10.5-52.7,15.1 c-0.9,0.2-1.8,0.4-2.7,0.7c-0.3-11.2,0.7-32.1,13.2-52.3c1.4-2.3,7.2-11.3,18.2-20.8c71.4-61.3,153.7-56,153.7-56 c78.1,5,128.4,60.4,130.5,57.4c2.2-3.1-43.7-60.3-117.5-77.2c-97.3-22.3-194,37.3-224.8,86.8c-10.1,16.3-21.1,33.8-22.5,54.7 c-0.3,4.3-1.1,20.6-3,52.2v0c-2.1,33.3-9,61.2-19.5,84.4l45.8,2c3.8-9.1,7.6-18.3,11.4-27.4l39.1-32.4l-33.1,37.6v34.2l-0.1,0v52.3 c0.2,4.3,0.3,8.5,0.5,12.8c19.3-21,38.7-42,58-62.9h50.8l-47.5,5.1l-58.9,65.9l14.6,103.1l-32.3,111.2h28.8L293,607l18.8-48.2 L321,535l24.1-62.2l-12.2,63.6l68.5,24l75.1-6.9l24.8-16.2l-36.6-37.4l33.9,25.7l9.6,7.3l63.5,48.5l30.1,23l-5.9,86.3h24.3 l7.2-82.5L587.4,511.4L587.4,511.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -2489.4248,
    y1: -1562.6543,
    x2: -2449.6406,
    y2: -1562.6543,
    gradientTransform: "matrix(0.9864 -0.684 -0.5778 -0.8333 1771.2711 -2684.8215)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#19A29B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M260.1,296.3c1.3,3.3-7.9,11.3-16.4,15.7c-11.1,5.9-26.1,8.3-27.5,4.7c-1.7-4.4,15.6-18.8,33-21.5 C251.6,294.8,259.1,293.7,260.1,296.3L260.1,296.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImxIcon);
export default __webpack_public_path__ + "static/media/imx_icon.f44180718e8fb725dba429c33482a85a.svg";
export { ForwardRef as ReactComponent };